import React from "react";
import { FlexContainer, LottieLoadingIndicator } from "src/components";
import { LoadingIndicatorButton } from "src/scenes/Survey/components/Utils";
import { ActionButton, TextLabel } from "./style";
import Dns from "src/img/dns.svg";

export default function DomainAuth({
    domainAuthenticated,
    customDomainIsApplied,
    setShowDns,
    dnsIsLoading,
    revalidateDomain
}) {
    return (
        <FlexContainer
            direction="row"
            tDirection="row"
            width="100%"
            gap="10px"
            border="1px solid #D8DEEC"
            maxHeight="50px"
            borderRadius="10px"
            padding="10px"
            alignItems="center"
            style={{ boxShadow: "0px 3px 6px #00000029" }}
        >
            <img src={Dns} width="33px" height="33px"/>
            <TextLabel marginBottom="0px" style={{ flexGrow: 1 }}>
                {
                    domainAuthenticated ?
                        "Domain is authenticated." :
                        (
                            customDomainIsApplied ?
                                "Domain is not authenticated." :
                                "Sending from a custom address requires authentication."
                        )
                }
            </TextLabel>
            { customDomainIsApplied &&
                <TextLabel
                    color="#016CFF"
                    marginBottom="0px"
                    style={{
                        textDecoration: "underline",
                        cursor: "pointer",
                    }}
                    onClick={() => setShowDns(true)}
                >
                    View DNS records
                </TextLabel>
            }
            { customDomainIsApplied && domainAuthenticated &&
                <ActionButton
                    border="1px solid #26A26B"
                    color="#26A26B"
                    backgroundColor="#E6FFF8"
                >
                    Authenticated
                </ActionButton>
            }
            { customDomainIsApplied && !domainAuthenticated &&
                (dnsIsLoading ?
                    <LoadingIndicatorButton width="138px">
                        <LottieLoadingIndicator height="2rem" width="2rem" margin="auto" containerHeight="2rem" />
                    </LoadingIndicatorButton>
                    :
                    <ActionButton
                        border="1px solid #171A22"
                        backgroundColor="#171A22"
                        color="#FFFFFF"
                        onClick={revalidateDomain}
                    >
                        Authenticate
                    </ActionButton>
                )
            }
        </FlexContainer>
    );
}
